/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, localDateString } from '../runtime';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';

/**
 *
 * @export
 * @interface EventModel
 */
export interface EventModel {
    /**
     *
     * @type {string}
     * @memberof EventModel
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof EventModel
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof EventModel
     */
    description: string;
    /**
     *
     * @type {string}
     * @memberof EventModel
     */
    link: string;
    /**
     *
     * @type {Date}
     * @memberof EventModel
     */
    date: Date;
    /**
     *
     * @type {FileUrl}
     * @memberof EventModel
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the EventModel interface.
 */
export function instanceOfEventModel(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('description' in value)) return false;
    if (!('link' in value)) return false;
    if (!('date' in value)) return false;
    return true;
}

export function EventModelFromJSON(json: any): EventModel {
    return EventModelFromJSONTyped(json, false);
}

export function EventModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventModel {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        description: json['description'],
        link: json['link'],
        date: new Date(json['date']),
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function EventModelToJSON(value?: EventModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        description: value['description'],
        link: value['link'],
        date: localDateString(value['date']),
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
